module.exports = __webpack_public_path__ + "img/login-2.0086304e.png";